export const MENTION_TOKEN_PREFIX = '@@mention:';
export const MENTION_TOKEN_SUFFIX = '@@';

export const MENTION_TOKEN_CAPTURE_REGEX = /@@mention:([\w-]+)@@/;

// Useful when splitting a string into normal text + mention tokens.
export const MENTION_TOKEN_SPLIT_REGEX = /(@@mention:[\w-]+@@)/g;

export const MENTION_FALLBACK_VALUE = 'Unknown';
